import React, {Component} from 'react';
import copy from 'copy-to-clipboard';
import withErrorHandler from '../../../../containers/hoc/withErrorHandler/withErrorHandler';

import axios from '../../../../axios-drops';

import TrdResult from '../TrdResult/TrdResult';
import Spinner from '../../Spinner/Spinner';
import Aux from '../../../../containers/hoc/Auxiliary';
import CopyButton from '../../../UI/Buttons/CopyButton/CopyButton';
import Switch from '../../../UI/Buttons/Switch/Switch';
import TrdResultLess from '../../TrdAdminFocus/TrdResultLess/TrdResultLess';
import CalcWarning from '../../../UI/CalcWarning/CalcWarning';
import FlashModal from '../../Modal/FlashModal/FlashModal';
import PaginationButton from '../../Buttons/PaginationButton/PaginationButton';

import classes from './TrdResults.css';


class trdResults extends Component {

    state = {
        results: [],
        winners: [],
        resultsShort: [],
        winnersShort: [],
        showFullResults: false,
        loading: true,
        shuffling: false,
        showInfo: false,
        switchPressed: false,
        alreadyPlayed: null,
        numberOfShuffles: null,
        newRandom: null,
        highlight: false,
        shuffled: false,
        copyPressed: false,
        resultsPerPage: 100,
        pageNumber: 1,
        hideMoreButton: false,
        
    }

 
    componentDidMount() { 

        let time = 5000
        let setPayPal = new Set()
        

        if (this.props.alreadyPlayed) {
            time = 100
        }

        const shuffles = this.getRandomShuffles();
        // const shuffles = 3;

        setTimeout( async () => {
            await axios.get('/registrations/' + this.props.dropId + '.json')
            .then(response => {
                
                
                let results = [];
                let winners = [];
                let winnersShort = [];
                let resultsShort = [];
                let hideMoreButton = false

                let firstIterationThru = true;

                for (let key in response.data) {
                    for (let keyA in response.data[key]) {
                        // console.log('OUTER LOOP')
                        
                        if (this.props.alreadyPlayed){

                            if (response.data.winners[keyA] && firstIterationThru) {
                                // console.log('Winners loop')
                                for (let keyB in response.data.winners[keyA]) {
                                    winners.push({
                                        ...response.data.winners[keyA][keyB],
                                        id: keyB
                                    })
                                } 
                                firstIterationThru = false;
                                // console.log(winners)

                                for (let i = 0; i < this.state.resultsPerPage; ++i) {
                                    if (i < winners.length) {
                                        winnersShort.push(winners[i])
                                    }
                                }
                            } 

                            

                            
                        } else {
                            if (response.data.general[keyA]) {
                            
                                if (setPayPal.size === 0) {   // first set entry

                                    setPayPal.add(response.data.general[keyA].paypal.trim().toLowerCase())    // put the user paypals into the set for double check

                                    results.push({                                 // push the first user onto results array
                                        ...response.data[key][keyA],
                                        id: keyA
                                    })

                                } else {                // not the first set entry
                                    
                                    if (!setPayPal.has(response.data.general[keyA].paypal.trim().toLowerCase())) {
                                        
                                        setPayPal.add(response.data.general[keyA].paypal.trim().toLowerCase())    // put the user paypals into the set for double check

                                        results.push({                                 // push the user onto results array
                                            ...response.data[key][keyA],
                                            id: keyA
                                        })
                                    } else {
                                        // console.log(response.data.general[keyA])
                                    }

                                }
  
                            }
                            hideMoreButton = true
                        }
                        
                    }
                }


                // start of fuckery check
                let testSet = new Set()
                let newResults = []
                let duplicateNames = new Set()
                
                results.forEach(entry => {

                    // if (entry.name === '-name here-') {
                    //     console.log('here')
                    // }

                    if (testSet.size === 0) {
                        testSet.add(entry.name)

                    } else {
                        if (testSet.has(entry.name)) {
                            console.log('--- found duplicates --- ')
                            duplicateNames.add(entry.name)
                        }
                        testSet.add(entry.name)
                    }
                })

                results.forEach(async entry => {
                    if (duplicateNames.has(entry.name)){
                        // console.log( entry.name + ' ' + entry.ip + ' ' + entry.paypal)
                        const doubleDipper = {
                            name: entry.name,
                            ip: entry.ip,
                            paypay: entry.paypal
                            
                        }
                        // console.log("[upload updated Drop info after win]")
    
                        await axios.post('/doubleDippers/' + this.props.dropId + '.json', doubleDipper)

                    } else {
                        newResults.push(entry)
                    }

                    
                })

                // console.log(newResults)
                
                // end of fuckery check 

               

                // get top 100 results for shuffle
                // for this list i dont use pagination this because this list shuffles anyways. 
                // only real pagination is used for the winners list
                for (let i = 0; i < (this.state.pageNumber * this.state.resultsPerPage); ++i) {
                    if (i < results.length) {
                        resultsShort.push(newResults[i])
                    } 
                    // else {
                        // hideMoreButton = true
                    // }
                }


                // setting state during initial Component Mount 
                this.setState({results: newResults,
                                resultsShort: resultsShort, 
                                loading: false,
                                hideMoreButton: hideMoreButton,
                                numberOfShuffles: shuffles, 
                                winners: winners,
                                winnersShort: winnersShort,
                                alreadyPlayed: this.props.alreadyPlayed,
                                showInfo: this.props.dropInfo.showInfo})
                
            })
        },time)
    }

    // Temporary comment out //

    componentWillUnmount = async () => {

        if (this.state.switchPressed) {
            const dropUpdate = {
                name: this.props.dropInfo.name,
                variant: this.props.dropInfo.variant,
                image: this.props.dropInfo.image,
                edition: this.props.dropInfo.edition,
                originallyAvailable: this.props.dropInfo.originallyAvailable,
                availability: 0,
                cost: this.props.dropInfo.cost,
                showInfo: this.state.showInfo,
                current: false,
                dropClosed: true,
                type: this.props.dropInfo.type,
                imageName: this.props.dropInfo.imageName
            }
            // console.log('[updating database after switch press and unmount]')
            await axios.patch('/drops/' + this.props.dropId + '.json', dropUpdate)
            
        }
        
        
    }


    getRandomShuffles = () => {
        return Math.floor(Math.random() * Math.floor(3)) + 2
    }

    

    convertArrayToObject = (array) => {
        const obj = {}
        let index = 0;

        array.forEach(element => {
            obj[index++] = element
        });

        return obj
    }

  

    updateDropInfo = async () => {
 
        const dropUpdate = {
            name: this.props.dropInfo.name,
            variant: this.props.dropInfo.variant,
            image: this.props.dropInfo.image,
            edition: this.props.dropInfo.edition,
            originallyAvailable: this.props.dropInfo.originallyAvailable,
            availability: 0,
            cost: this.props.dropInfo.cost,
            showInfo: false,
            current: false,  
            dropClosed: true,
            type: this.props.dropInfo.type,
            imageName: this.props.dropInfo.imageName
        }
        // console.log("[upload updated Drop info after win]")
        await axios.patch('/drops/' + this.props.dropId + '.json', dropUpdate)

    }

    uploadResults = async () => {

        const tempObj = this.convertArrayToObject(this.state.winners)
        
        this.updateDropInfo()
        
        // console.log("[upload winning registrations]")
        await axios.post('/registrations/' + this.props.dropId + '/winners.json', tempObj)

    }


    shuffleList = () => {

        let tempArray = [...this.state.results]
        let shortList = []

        for (let i = tempArray.length - 1; i > 0; --i) {
            const rand = Math.floor(Math.random() * i)
            const temp = tempArray[i]
            tempArray[i] = tempArray[rand]
            tempArray[rand] = temp
        }
        // console.log("[shuffling list]")

        for (let i = 0; i < (this.state.pageNumber * this.state.resultsPerPage); ++i) {
            if (i < tempArray.length) {
                shortList.push(tempArray[i])
            } 
        }
        // console.log(shortList.toString())
        

        this.setState({results: tempArray, resultsShort: shortList, shuffled: true})
    }

    showCopiedMessage = () => {
        // alert("copied")
        this.setState({copyPressed: true})

        setTimeout(() => {
            this.setState({copyPressed: false})
               
        }, 1000)
    }

    
    

 
    copyNamesClickedHandler = () => {
        
        const tempArray = []

        for (let i = 0; i < this.props.dropInfo.originallyAvailable; ++i) {
            tempArray.push((i+1) + ". " + this.state.winners[i].name)
        }
    
        copy(tempArray.join('\n'))

        this.showCopiedMessage()
    } 
    

    paypalClickedHandler = () => {
        const tempArray = []

        for (let i = 0; i < this.props.dropInfo.originallyAvailable; ++i) {
            tempArray.push(this.state.winners[i].paypal)
        }
        copy(tempArray.join('\n'))
        this.showCopiedMessage()
    } 
    

    otherClickedHandler = async () => {
        
        const result = await axios.get('/email-list.json')
        const tempArray = []
        // console.log(result.data)

        for( let key in result.data) {
            // console.log(result.data[key].email)
            tempArray.push(result.data[key].email)
        }
        
        // this.state.winners.forEach(element => {
        //     if (element.other !== undefined) {
        //         tempArray.push(element.other)
        //     }
        // });
        copy(tempArray.join(';\n'))
        this.showCopiedMessage()
    }


    switchToggleHandler = () => {

        if (this.state.showInfo) {           
            this.setState({
                showInfo:false,
                switchPressed:true})                
        } else {
            this.setState({
                showInfo:true,
                switchPressed:true})
        }

    }

    paginationHandler = () => {
        // console.log("paginate")
        let hideMoreButton = false;
        let tempArray = []
        let pageNumber = this.state.pageNumber
        ++pageNumber
        const resultsPerPage = this.state.resultsPerPage

        for (let i = 0; i < (pageNumber * resultsPerPage); ++i) {
            if (i < this.state.winners.length) {
                tempArray.push(this.state.winners[i])
            } 
        }

        if (pageNumber * resultsPerPage >= this.state.winners.length) {
            hideMoreButton = true
        }

        this.setState({winnersShort: tempArray,
                        pageNumber: pageNumber,
                        hideMoreButton: hideMoreButton})


    }
    


    render() {

        if (this.state.numberOfShuffles !== null && !this.state.loading && !this.props.alreadyPlayed) {
            
            if ( !this.state.shuffling && this.state.numberOfShuffles > 0) {
                
                let numShuffles = this.state.numberOfShuffles
    
                --numShuffles

                // console.log("[right before 2 second timeout]")
                setTimeout(() => {
                    this.setState({shuffling: true,
                        shuffled: false,
                        numberOfShuffles: numShuffles
                    })
                    this.shuffleList()
                    // console.log("[after 2 second timeout]")       
                }, 5000)
                
            }      
        }

        let trdResults = null 

        if (this.state.results.length > 0 && this.state.winners.length === 0) {

            if (this.state.showInfo) {
                trdResults = (
                    <div>
                        {this.state.resultsShort.map((item, index) => {
    
                            const highlight = index < this.props.dropInfo.originallyAvailable
                            
                            return (
                            <TrdResult
                                key={item.id}
                                index={index}
                                name={item.name}
                                paypal={item.paypal}
                                // other={item.other} 
                                highlight={highlight}/>
                        )})}
                    </div>
                )
            } else {
                trdResults = (
                    <div>
                        {this.state.resultsShort.map((item, index) => {
    
                            const highlight = index < this.props.dropInfo.originallyAvailable
                            
                            return (
                            <TrdResultLess
                                key={item.id}
                                index={index}
                                name={item.name}
                                highlight={highlight}/>
                        )})}
                    </div>
                )
            }
           
        }

        if (this.state.winners.length > 0 && this.state.alreadyPlayed) {

            if (this.state.showInfo) {
                trdResults = (
                    <div>
                        {this.state.winnersShort.map((item, index) => {
    
                            const highlight = index < this.props.dropInfo.originallyAvailable
                            return (
                            <TrdResult
                                key={item.id}
                                index={index}
                                name={item.name}
                                paypal={item.paypal}
                                // other={item.other} 
                                highlight={highlight}/>
                        )})}
                    </div>
                )
            } else {
                trdResults = (
                    <div>
                        {this.state.winnersShort.map((item, index) => {
    
                            const highlight = index < this.props.dropInfo.originallyAvailable
                            
                            return (
                            <TrdResultLess
                                key={item.id}
                                index={index}
                                name={item.name}
                                highlight={highlight}/>
                        )})}
                    </div>
                )
            }            
            
        }

        
      

        let output = 
            <Aux>
                <div className={classes.ShufflingTitle}>
                  
                    <h2>Calculating...</h2>
                </div>
                <Spinner />
            </Aux>

        if (this.props.bttnClicked) {
            output = 
            <Aux>
                <div className={classes.ShufflingTitle}>
                    <CalcWarning />
                    <h2>Calculating...</h2>
                </div>
                <Spinner />
            </Aux>
        }


        let gameResults = null

        if (this.state.shuffling 
            //  && this.state.numberOfShuffles > 0
            && this.state.shuffled
         ) {
            // console.log('[right before 5 sec timeout]')
            setTimeout(() => {
                if (this.state.numberOfShuffles === 0 
                    // && this.state.alreadyPlayed
                    ) {
                    // console.log("[setting winners array with final list]")
                    const winners = [...this.state.results];
                    let shortList = []

                    for (let i = 0; i < (this.state.pageNumber * this.state.resultsPerPage); ++i) {
                        if (i < winners.length) {
                            shortList.push(winners[i])
                        } 
                    }

                    // let hideMoreButton = false

                    const hideMoreButton = (this.state.pageNumber * this.state.resultsPerPage >= winners.length)? true: false

                    this.setState({
                        shuffling: false, 
                        alreadyPlayed: true,
                        winners: winners,
                        winnersShort: shortList,
                        hideMoreButton: hideMoreButton
                    });
                    this.uploadResults();
                }
                else {
                    
                    this.setState({ shuffling: false });
                }

                // console.log("[after 5 sec timeout]")
            }, 4500)
    
        
            gameResults = 
                <Aux>
                    <Spinner />
                </Aux>
                
        } else {
            gameResults = 
                <div className={classes.GameResults}>
                    
                    {trdResults}
                    {this.state.hideMoreButton ? null : <PaginationButton paginationClicked={this.paginationHandler}/>}
                </div>
        }

            

        if (!this.state.loading && !this.state.winners.length > 0) {
            output =
            <Aux>
                <div className={classes.ShufflingTitle}>
                    <CalcWarning />
                    <h2>Shuffling... x{this.state.numberOfShuffles}</h2>
                </div>
                {gameResults}
            </Aux>
        }


        if ((!this.state.loading && this.state.winners.length > 0 ) || (!this.state.loading && this.state.alreadyPlayed)) {
            output =
            <Aux>
                <FlashModal show={this.state.copyPressed}  >
                    Copied
                </FlashModal>
                <div className={classes.ShufflingTitle} 
                    >
                    <Switch 
                        isOn={this.state.showInfo} 
                        handleToggle={this.switchToggleHandler}/>
                    <h2>Winners!</h2>
                    <CopyButton copyNamesClicked={this.copyNamesClickedHandler} 
                        paypalClicked={this.paypalClickedHandler} 
                        otherClicked={this.otherClickedHandler}/>
                </div>
                {gameResults}
            </Aux>
        }


        return (
            <div className={classes.TrdResults}>
                {output}
            </div>
        )
            
    }
}


export default withErrorHandler(trdResults, axios)


// WEBPACK FOOTER //
// ./src/components/UI/TrdAdminFocus/TrdResults/TrdResults.js